module.exports = __webpack_public_path__ + "static/cosi6-ad15ce8d0c0c8847b6541af4d0f3d20a.jpg";